import { Box, Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import AcadmicYearsUI from "../components/academicYear/AcadmicYearsUI";
import ClassSubjectsUI from "../components/classSubjects/ClassSubjectsUI";
import GradesUI from "../components/grade/GradesUI";
import SectionsUI from "../components/section/SectionsUI";
import SubjectsUI from "../components/subject/SubjectsUI";
import BellScheduleUI from "../components/periods/BellScheduleUI";
import GradePeriodsUI from "../components/periods/GradePeriodsUI";

// In setup order: each tab depends only on the ones before it.
const TABS = [
  { key: "years", label: "Academic Years" },
  { key: "sections", label: "Sections" },
  { key: "grades", label: "Grades" },
  { key: "subjects", label: "Subjects" },
  { key: "class-subjects", label: "Class Subjects" },
  { key: "bell-schedule", label: "Bell Schedule" },
  { key: "grade-periods", label: "Grade Periods" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

/**
 * Academics → Setup: Academic Years, Sections, Grades, Subjects, Class Subjects, Bell Schedule and
 * Grade Periods as tabs.
 * The tab is kept in the URL (?tab=...); each screen puts its filters and Add button on the right
 * of the same top bar.
 */
export default function AcademicsSetupPage() {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const tab: TabKey = TABS.some((t) => t.key === requested) ? (requested as TabKey) : "years";

  const tabs = (
    <Tabs
      value={tab}
      onChange={(_, next: TabKey) => setParams({ tab: next }, { replace: true })}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ minHeight: 40 }}
    >
      {TABS.map((t) => (
        <Tab key={t.key} value={t.key} label={t.label} sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }} />
      ))}
    </Tabs>
  );

  return (
    <Box sx={{ mt: 2, mr: 2 }}>
      {tab === "years" && <AcadmicYearsUI tabs={tabs} />}
      {tab === "sections" && <SectionsUI tabs={tabs} />}
      {tab === "grades" && <GradesUI tabs={tabs} />}
      {tab === "subjects" && <SubjectsUI tabs={tabs} />}
      {tab === "class-subjects" && <ClassSubjectsUI tabs={tabs} />}
      {tab === "bell-schedule" && <BellScheduleUI tabs={tabs} />}
      {tab === "grade-periods" && <GradePeriodsUI tabs={tabs} />}
    </Box>
  );
}
